module.exports = __webpack_public_path__ + "6c473114777c3174c98ddb6d8c8bd7ef.ttf";